import { Capacitor } from '@capacitor/core'
import { InAppReview } from '@capacitor-community/in-app-review'

export type InAppReviewTrigger = 'groceryAdd' | 'discountClaim' | 'flyerOpen'

const STORAGE_KEY = 'in_app_review_last_at'
const COOLDOWN_MS = 90 * 24 * 60 * 60 * 1000

const CHANCES: Record<InAppReviewTrigger, number> = {
  groceryAdd: 0.04,
  discountClaim: 0.25,
  flyerOpen: 0.015,
}

export function useInAppReview() {
  async function maybeRequestReview(trigger: InAppReviewTrigger): Promise<void> {
    if (!import.meta.client || !Capacitor.isNativePlatform()) {
      return
    }

    try {
      const lastAtRaw = localStorage.getItem(STORAGE_KEY)
      const lastAt = lastAtRaw ? Number(lastAtRaw) : 0
      if (lastAt && Date.now() - lastAt < COOLDOWN_MS) {
        return
      }

      if (Math.random() >= CHANCES[trigger]) {
        return
      }

      localStorage.setItem(STORAGE_KEY, String(Date.now()))
      await InAppReview.requestReview()
    }
    catch {
      // Native review dialog is best-effort; OS may also silently ignore.
    }
  }

  return {
    maybeRequestReview,
  }
}
